import { API_URL } from '../../../../../actions/utilAction';
import { actionCreator,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrlForCustomAPI,
  downloadFilesOnAPICall,  
  extractDataFromObject,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from '../../../../../actions/utilAction';

export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrlForCustomAPI,
  create_post_data,
  downloadFilesOnAPICall,
  showSuccessMessage,
  showErrorMessage,
  extractDataFromObject,
  API_URL,
  showWarningMessage,
};



export const GET_PATIENT_APPOINTMENT_LIST_FOR_AGENCY = `${API_URL}/api/PatientAppointments/GetPatientAppointmentListForAgency`;
export const POST_EMCOUNTER_WITH_SIGNATURE_AND_GENERATE_CLAIM_FOR_AGENCY = `${API_URL}/patient-encounter/SaveEncounterWithSignatureAndGenerateClaimForAgency`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const CANCEL_APPOINTMENT_API = `${API_URL}/api/PatientAppointments/CancelAppointments`;

export const  manageAppointmentsActionTypes = {
  get_patient_appointment_list: createRequestActionTypes('GET_PATIENT_APPOINTMENT_LIST'),
  save_encounter_with_signature: createRequestActionTypes('SAVE_ENCOUNTER_WITH_SIGNATURE'),
  get_masterdata: createRequestActionTypes('GET_MASTERSDATA'),
  cancel_appointment: createRequestActionTypes('CANCEL_APPOINTMENT'),
};



// WEBPACK FOOTER //
// ./src/modules/ManageAppointments/components/appointments/constants/ApiConstants.js